import React, { useEffect, useState } from 'react';
import { Autocomplete, Typography } from '@mui/material';
import { FullCalendarComponent } from './FullCalendar';
import { handleError, handleWarning, isAdmin } from '../../helpers/utils';
import { convertDataToEvents, getPPC } from '../../actions/calendar';
import { AREAS_PRIORITY, MONTHS } from '../utils/lists';
import { useSelector } from 'react-redux';
import { SelectComponent } from '../orders/SummaryResults';
import { getCurrentMonth } from '../../helpers/hours';
import { Grid } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { generateProductionPlanPDF } from '../utils/ProductionPlanPDF';

export const ProductionPlan = () => {
	// State
	const [orderChips, setOrderChips] = useState([]);
	const [eventBiases, setEventBiases] = useState([]);
	const [responseData, setResponseData] = useState({});
	const [priorityOrder, setPriorityOrder] = useState(AREAS_PRIORITY);
	const [month, setMonth] = useState(getCurrentMonth());

	// Redux store
	const { user } = useSelector((state) => state);

	// Handle reset calendar
	const resetCalendar = () => {
		setOrderChips([]);
		setEventBiases([]);
		setResponseData({});
	};

	useEffect(() => {
		const getNewOrderChipListAreas = () => {
			const monthNumber = MONTHS.find((x) => x.name === month).number;
			getPPC(user.area?.name, monthNumber)
				.then(({ data }) => {
					if (data.ok) {
						setResponseData(data.event_biases);
						// Update event biases
						setEventBiases(
							convertDataToEvents(
								data.event_biases,
								AREAS_PRIORITY
							)
						);
					} else {
						handleError(
							data.error,
							'Ocurrió un error al intentar procesar la orden'
						);
					}
				})
				.catch((error) => {
					handleError(error, error);
				});
		};

		if (eventBiases.length > 0 || Object.keys(responseData).length > 0) {
			// Update event biases
			setEventBiases(convertDataToEvents(responseData, priorityOrder));
		} else {
			// Fetch production plan calendar
			getNewOrderChipListAreas();
		}
	}, [priorityOrder, month]);

	return (
		<div style={divStyle}>
			{/* Header */}
			<Grid
				container
				spacing={3}
				style={{ padding: '35px 20px 20px 20px', margin: '0 0 0 10px' }}
			>
				{/* Title for indicators */}
				<Grid item xs={7}>
					<Typography
						variant='h4'
						color='textSecondary'
						align='left'
						style={{ margin: '5px 0 0 20px' }}
					>
						{isAdmin(user)
							? 'Plan de producción'
							: 'Mi plan de producción'}
					</Typography>
				</Grid>

				{/* Month */}
				<Grid item xs={2}>
					<Autocomplete
						required
						disableClearable
						style={{ margin: '-17px 0 0 80px' }}
						fullWidth
						value={month}
						onChange={(_, value) => {
							resetCalendar();
							setMonth(value);
						}}
						options={MONTHS.map((item) => item.name)}
						renderInput={(params) => SelectComponent(params, 'Mes')}
					/>
				</Grid>

				{/* Generate PDF */}
				<Grid item xs={1}/>
				<Grid item xs={1}>
					<Button onClick={() => {
						if(eventBiases?.length >= 1){
							generateProductionPlanPDF(priorityOrder, month, eventBiases, user.first_name);
						}else{
							handleWarning(`No tienes tareas para el mes de ${month}`);
						}
					}}>
						<PictureAsPdfIcon />
					</Button>
				</Grid>

				{/* Excel data download */}
				{/* <Grid item xs={2}>
					<Button
						variant='contained'
						color='success'
						onClick={handleDownloadExcelReport}
					>
						Descargar Excel
					</Button>
				</Grid> */}
			</Grid>

			{/* Calendar with sidebar areas */}
			<FullCalendarComponent
				chips={orderChips}
				responseData={responseData}
				data={eventBiases}
				resetCalendar={resetCalendar}
				priorityOrder={priorityOrder}
				setPriorityOrder={setPriorityOrder}
				user={user}
				month={month}
			/>
		</div>
	);
};

const HeaderCalendar = ({ isUserAdmin = false }) => (
	<center style={centerStyle}>
		<Typography variant='h4' gutterBottom>
			{isUserAdmin ? 'Plan de producción' : 'Mi plan de producción'}
		</Typography>
	</center>
);

const divStyle = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-evenly',
};

const centerStyle = { margin: '20px 0 0 0' };
